"use client";
var ae = Object.defineProperty;
var ce = (e, t, n) => t in e ? ae(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var I = (e, t, n) => ce(e, typeof t != "symbol" ? t + "" : t, n);
import { W as z, g as G, o as M, p as le, j as $, L as Y, k as de, f as J, q as ue, r as q, l as fe, b as ge, h as E, a as he, m as pe, c as we } from "./wallet-store-DAAcC-x-.js";
import { i as V } from "./identity-Fm37nNMc.js";
import { e as be } from "./entries-CRQPbdRb.js";
class Q {
  constructor(t, n, s, r) {
    I(this, "_isDisconnected", !1);
    this.info = t, this.defaultApi = n, this._enabledApi = s, this._enable = r;
  }
  async reenable() {
    const t = await this._enable();
    return t ? (this._enabledApi = t, !0) : !1;
  }
  get enabledApi() {
    return this._enabledApi;
  }
  /**
   * Gets the change address for the wallet.
   * @returns The change address in hex format.
   */
  async getChangeAddressHex() {
    return this._enabledApi.getChangeAddress();
  }
  /**
   * Gets the change address for the wallet.
   * @returns The change address in Bech32 format.
   */
  async getChangeAddressBech32() {
    const t = await this.getChangeAddressHex();
    return j(t);
  }
  /**
   * Gets the stake address for the wallet.
   * @returns The stake address in hex format.
   */
  async getStakeAddressHex() {
    return (await this._enabledApi.getRewardAddresses())[0];
  }
  /**
   * Gets the stake address for the wallet.
   * @returns The stake address in Bech32 format.
   */
  async getStakeAddressBech32() {
    const t = await this.getStakeAddressHex();
    return j(t);
  }
  /**
   * Gets the network ID for the wallet.
   * @returns The network ID.
   */
  async getNetworkId() {
    return this._enabledApi.getNetworkId();
  }
  /**
   * Gets the balance for the wallet in CBOR format.
   * @returns The balance in CBOR format.
   */
  async getBalance() {
    return this._enabledApi.getBalance();
  }
  /**
   * Gets the default API for the wallet.
   * @returns The default wallet API.
   */
  getDefaultApi() {
    return this.defaultApi;
  }
  /**
   * Checks if the wallet is connected.
   * @returns True if the wallet is connected, otherwise false.
   */
  async isConnected() {
    return this.defaultApi.isEnabled();
  }
  /**
   * Checks if the wallet is connected to a specific wallet key.
   * @param wallet - The wallet key to check.
   * @returns True if connected to the specified wallet key, otherwise false.
   */
  async isConnectedTo(t) {
    return this.info.key !== t ? !1 : this.isConnected();
  }
  /**
   * Gets the UTXOs for the wallet.
   * @returns The UTXOs.
   */
  async getUtxos() {
    return this._enabledApi.getUtxos();
  }
  /**
   * Signs a transaction.
   * @param tx - The transaction to sign.
   * @param [partialSign=true] - Whether to partially sign the transaction.
   * @returns The signed transaction.
   */
  async signTx(t, n = !0) {
    return this._enabledApi.signTx(t, n);
  }
  /**
   * Submits a transaction.
   * @param tx - The transaction to submit.
   * @returns
   */
  async submitTx(t) {
    return this._enabledApi.submitTx(t);
  }
  /**
   * Signs data with the wallet's stake address.
   * @param payload - The data to sign.
   * @returns The signed data.
   */
  async signData(t) {
    const n = await this.getStakeAddressHex();
    return this._enabledApi.signData(n, t);
  }
  get isDisconnected() {
    return this._isDisconnected;
  }
  async disconnect() {
    this._isDisconnected = !0;
  }
}
function R(e) {
  return async (t) => {
    const n = await ne({ key: t });
    if (!n) {
      const i = "Could not retrieve the wallet API";
      throw new z(i);
    }
    const s = G({ key: t, defaultApi: n }), r = () => Pe(n), c = await r();
    if (!c) {
      const i = "Could not enable the wallet";
      throw new z(i);
    }
    let a;
    return e ? a = new e(s, n, c, r) : a = new Q(s, n, c, r), a;
  };
}
function X({ connector: e, initialize: t }) {
  return {
    connector: e ?? R(),
    initialize: t
  };
}
function B() {
  let e = V, t = V;
  return { promise: new Promise((s, r) => {
    e = s, t = r;
  }), resolve: e, reject: t };
}
function Z(e) {
  let t = { status: "idle" };
  return async () => {
    if (t.status === "initialized")
      return;
    if (t.status === "loading")
      return t.promise;
    const { promise: n, resolve: s } = B();
    return t = { status: "loading", promise: n }, t = { status: await e() ? "initialized" : "idle" }, s(), n;
  };
}
function S(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function ye(e) {
  const t = "DAppConnectorBridge: ";
  let n = null, s = null, r = null;
  const c = { type: "cardano-dapp-connector-bridge", source: null, origin: null }, a = {}, i = {
    // Initial 3 methods to establish connection. More endpoints will be added by the wallet.
    connect: "connect",
    handshake: "handshake",
    enable: "enable",
    isEnabled: "isEnabled"
  };
  function p() {
    return ("000" + (Math.random() * 46656 | 0).toString(36)).slice(-3) + ("000" + (Math.random() * 46656 | 0).toString(36)).slice(-3);
  }
  function h(d) {
    const g = [...arguments];
    return g.length > 0 && g.shift(), new Promise((o, l) => {
      var x;
      const u = {
        payload: {
          type: c.type,
          to: n,
          uid: p(),
          method: d,
          args: g
        },
        resolve: o,
        reject: l
      };
      a[u.payload.uid] = u, (x = c.source) == null || x.postMessage(u.payload, c.origin);
    });
  }
  function w(d) {
    return function() {
      return h(d, ...arguments);
    };
  }
  function f(d) {
    const g = {};
    for (const o in d) {
      const l = d[o];
      typeof l == "string" ? o === "feeAddress" ? g[o] = l : (g[o] = w(l), i[l] = l) : typeof l == "object" ? g[o] = f(l) : g[o] = l;
    }
    return g;
  }
  function b(d, g, o, l) {
    if (S(window, "cardano") || (window.cardano = {}), S(window.cardano, o))
      return console.warn(
        "Warn: " + t + "window.cardano." + o + " already present, skipping initialApi creation."
      ), null;
    c.source = d, c.origin = g, n = o;
    const u = {
      isBridge: !0,
      // https://github.com/cardano-foundation/CIPs/tree/master/CIP-0030
      isEnabled: function() {
        return h("isEnabled");
      },
      enable: function() {
        return h("enable");
      },
      apiVersion: l.apiVersion,
      name: l.name,
      icon: l.icon ? l.icon : null,
      // extension: https://github.com/cardano-foundation/CIPs/pull/183
      experimental: {}
    };
    return window.cardano[o] = u, l.experimental && (u.experimental = {
      ...f(l.experimental)
    }), window.cardano[o];
  }
  function m(d) {
    if (!s) {
      if (d.data.method !== i.connect)
        return console.error("Error: " + t + "send 'connect' first."), !1;
      const g = d.data.initialApi;
      if (!g || !g.isBridge || !g.apiVersion || !g.name)
        return console.error("Error: " + t + "'connect' is missing correct initialApi.", g), !1;
      if (!d.data.walletNamespace)
        return console.error(
          "Error: " + t + "'connect' is missing walletNamespace.",
          d.data.walletNamespace
        ), !1;
      s = b(
        d.source,
        d.origin,
        d.data.walletNamespace,
        g
      );
    }
    return s && S(window, "cardano") && window.cardano[d.data.walletNamespace] === s ? !0 : (console.warn(
      "Warn: " + t + "bridge not set up correctly:",
      c,
      s,
      n
    ), !1);
  }
  function _(d) {
    return !(!d.data || !d.origin || !d.source || d.data.type !== c.type || !S(i, d.data.method) || n && d.data.walletNamespace !== n);
  }
  async function D(d) {
    if (!_(d) || !m(d)) return;
    if (d.data.method === i.connect) {
      await h("handshake") && s && e && e(s);
      return;
    }
    if (!d.data.uid) return;
    const g = a[d.data.uid];
    if (!g) return;
    let o = d.data.response;
    const l = d.data.error;
    if (l) {
      g.reject(l), delete a[d.data.uid];
      return;
    }
    d.data.method === i.enable && (r = null, typeof o == "object" && (r = {
      ...f(o)
    }, o = r)), g.resolve(o), delete a[d.data.uid];
  }
  window.addEventListener("message", D, !1);
}
function Ae() {
  const { promise: e, resolve: t, reject: n } = B(), s = setTimeout(() => n("Request took too long"), 1e4);
  return ye((r) => {
    clearTimeout(s), t(r);
  }), e;
}
const me = X({
  initialize: Z(async () => {
    try {
      if (typeof window > "u")
        return !1;
      const e = await Ae();
      return e.name === "eternl" ? (window.cardano.eternl = e, !0) : !1;
    } catch {
      return !1;
    }
  })
});
class xe extends Q {
  async disconnect() {
    super.disconnect(), M.getApi().hideWidget();
  }
}
const ve = X({
  initialize: Z(async () => (M.init("https://wallet.nu.fi"), le.initNufiDappCardanoSdk(M, "snap"), !0)),
  connector: R(xe)
}), L = {
  eternl: me,
  nufiSnap: ve
};
function _e(e) {
  return !!L[e];
}
function Ce() {
  return typeof window < "u";
}
const Ee = "Anvil Weld relies on DOM APIs and may produce unpredictable results if used outside of a browser environment.";
async function ke(e) {
  return !Ce() && !F.config.ignoreUnsafeUsageError && console.error(Ee), _e(e) ? L[e].connector(e) : R()(e);
}
function ee() {
  return {
    supportedMap: /* @__PURE__ */ new Map(),
    unsupportedMap: /* @__PURE__ */ new Map(),
    allMap: /* @__PURE__ */ new Map(),
    supportedArr: [],
    unsupportedArr: [],
    allArr: []
  };
}
function We() {
  return /* @__PURE__ */ new Map();
}
async function Ue({
  cache: e,
  getWalletInfo: t = G,
  getWalletExtensions: n = je
} = {}) {
  const s = await n(), r = ee();
  for (const c of s) {
    const a = t(c);
    let i;
    i = (e == null ? void 0 : e.get(c.defaultApi)) ?? { info: a, defaultApi: c.defaultApi }, e == null || e.set(c.defaultApi, i), r.allMap.set(a.key, i), r.allArr.push(i), a.supported ? (r.supportedMap.set(a.key, i), r.supportedArr.push(i)) : (r.unsupportedMap.set(a.key, i), r.unsupportedArr.push(i));
  }
  return r;
}
const Te = $(
  (e, t, {
    config: n = F.config,
    lifecycle: s = new Y(),
    cache: r = We(),
    getInstalledExtensions: c = Ue
  } = {}) => {
    const a = (f) => {
      var b, m, _;
      (b = n.onUpdateError) == null || b.call(n, "extensions", f), (_ = (m = n.extensions).onUpdateError) == null || _.call(m, f);
    }, i = async (f, b) => {
      n.debug && console.log("[WELD] Extensions state update");
      try {
        if (f != null && f.aborted) {
          b == null || b();
          return;
        }
        e({ isFetching: !0 });
        const m = await c({ cache: r });
        if (f != null && f.aborted) {
          b == null || b();
          return;
        }
        e({
          ...m,
          isLoading: !1,
          isFetching: !1
        });
      } catch (m) {
        a(m), e({
          isLoading: !1,
          isFetching: !1
        });
      }
    }, p = async () => {
      if (typeof window > "u")
        return;
      s.subscriptions.clearAll();
      const f = s.inFlight.add();
      try {
        if (await i(f), f.aborted)
          return;
        de((b) => i(f, b), s, n, "extensions");
      } finally {
        s.inFlight.remove(f);
      }
    }, h = () => {
      s.cleanup();
    };
    return {
      ...ee(),
      isLoading: !0,
      isFetching: !1,
      update: i,
      __init: p,
      __cleanup: h
    };
  }
);
function K(e, t) {
  return typeof e == "object" && e !== null && t in e;
}
function O(e) {
  if (e) {
    if (e instanceof Error || K(e, "message"))
      return e.message;
    if (K(e, "info"))
      return e.info;
    if (typeof e == "string")
      return e;
  }
}
function Ie(e) {
  return O(e) === "account changed";
}
function Be(e, t, n, { isAccountChangeError: s = Ie } = {}) {
  return new Proxy(e, {
    get(c, a, i) {
      const p = c[a];
      return typeof p != "function" ? Reflect.get(c, a, i) : (...h) => {
        const w = p.apply(c, h);
        return w instanceof Promise ? w.catch(async (f) => {
          if (s(f)) {
            const _ = (await t())[a];
            if (typeof _ != "function")
              throw f;
            return await _.apply(c, h);
          }
          throw await n() ? f : new J();
        }) : w;
      };
    }
  });
}
class De {
  constructor() {
    I(this, "_debug", !1);
  }
  withDebug(t = !0) {
    return this._debug = t, this;
  }
  _log(...t) {
    this._debug && console.log(...t);
  }
}
class He extends De {
  constructor() {
    super(...arguments);
    I(this, "_runningUpdate");
    I(this, "_lastId", 0);
  }
  start({ lifecycle: n }) {
    const s = this._nextId(), { promise: r, resolve: c } = B(), a = n.inFlight.add();
    this._log("starting", s), this._runningUpdate && (this._log("cancelling", this._runningUpdate.id), this._runningUpdate.signal.aborted = !0);
    const i = { id: s, promise: r, signal: a, resolve: c };
    return this._runningUpdate = i, {
      update: i,
      resolve: (p) => {
        var h;
        this._log("resolving", s), this._runningUpdate && this._runningUpdate !== i ? (this._log(s, "will resolve with", (h = this.runningUpdate) == null ? void 0 : h.id), this._runningUpdate.promise.then(i.resolve)) : (this._log("resolving", s, "as is"), i.resolve(p)), this._runningUpdate === i && (this._log("cleaning up on", s), this._runningUpdate = void 0);
      }
    };
  }
  get runningUpdate() {
    return this._runningUpdate;
  }
  _nextId() {
    return ++this._lastId;
  }
}
function te(e) {
  return typeof e == "object" && e !== null && "apiVersion" in e;
}
async function ne({
  key: e,
  maxRetryCount: t = 5,
  retryIntervalMs: n = 1e3
} = {}) {
  const { promise: s, resolve: r } = B();
  let c = 0;
  function a() {
    let i;
    if (e && typeof window.cardano == "object" && e in window.cardano) {
      const p = window.cardano[e];
      te(p) && (i = p);
    } else window.cardano && (i = window.cardano);
    i ? r(i) : ++c > t ? r(void 0) : setTimeout(a, n);
  }
  return a(), s;
}
const Se = ["ccvault"];
async function je(e) {
  const t = await ne(e);
  if (!t) return [];
  const n = (e == null ? void 0 : e.blacklist) ?? Se;
  for (const s of n)
    s in t && delete t[s];
  return Object.entries(t).flatMap(([s, r]) => te(r) ? {
    key: s,
    defaultApi: r
  } : []).sort((s, r) => {
    const c = s.key.toLowerCase(), a = r.key.toLowerCase();
    return c < a ? -1 : a < c ? 1 : 0;
  });
}
async function Pe(e, { maxRetryCount: t = 5, retryIntervalMs: n = 1e3 } = {}) {
  const { promise: s, resolve: r } = B();
  let c = 0;
  async function a() {
    try {
      if ("enable" in e) {
        const i = await e.enable();
        r(i);
        return;
      }
      if (++c > t)
        throw new Error("API not found");
      setTimeout(a, n);
    } catch {
      r(void 0);
    }
  }
  return a(), s;
}
function se(e, t) {
  for (const n of t)
    if (e.startsWith(n))
      return !0;
  return !1;
}
const Ne = 58, Me = ["e0", "e1"], Re = 116, Le = ["00", "01"];
function re(e) {
  return !!e && e.length === Ne && se(e, Me);
}
function Oe(e) {
  return !!e && e.length === Re && se(e, Le);
}
function Fe(e) {
  if (typeof e != "string")
    throw new TypeError("Expected input to be a string");
  if (e.length % 2 !== 0)
    throw new RangeError("Expected string to be an even number of characters");
  const t = new Uint8Array(e.length / 2);
  for (let n = 0; n < e.length; n += 2)
    t[n / 2] = Number.parseInt(e.substring(n, n + 2), 16);
  return t.buffer;
}
const ze = (e) => {
  const t = e.toString();
  let n = "";
  for (let s = 0; s < t.length; s += 2)
    n += String.fromCharCode(Number.parseInt(t.substring(s, s + 2), 16));
  return n;
};
function qe(e, t = "string") {
  let n = "", s;
  for (let r = 0; r < e.length; r++)
    s = e[r].toString(16), n += s.length === 1 ? `0${s}` : s;
  return n.startsWith("000de140") && (n = n.replace("000de140", "")), t === "hex" ? n : ze(n);
}
function ie(e) {
  return typeof e == "string" ? ue.decode(Fe(e)) : e;
}
function Ve(e, t) {
  const n = ie(e);
  let s = 0;
  if (typeof n == "number" && (s = n), Array.isArray(n)) {
    const a = n[0];
    typeof a == "number" && (s = a);
  }
  if (t === "lovelace")
    return s;
  let r = {};
  if (Array.isArray(n)) {
    const a = n[1];
    typeof a == "object" && a !== null && (r = a);
  }
  if (typeof t == "object") {
    for (const [a, i] of Object.entries(r))
      if (!(typeof i != "object" || i === null || U(a) !== t.policyId))
        for (const [h, w] of Object.entries(i)) {
          if (typeof w != "number")
            continue;
          if (U(h) === t.assetName)
            return w;
        }
    return 0;
  }
  if (t) {
    for (const [a, i] of Object.entries(r)) {
      if (typeof i != "object" || i === null || U(a) !== t)
        continue;
      const h = {};
      for (const [w, f] of Object.entries(i)) {
        if (typeof f != "number")
          continue;
        const b = U(w);
        h[b] = f;
      }
      return h;
    }
    return {};
  }
  const c = { cardano: { lovelace: s } };
  for (const [a, i] of Object.entries(r)) {
    if (typeof i != "object" || i === null)
      continue;
    const p = U(a);
    c[p] = {};
    for (const [h, w] of Object.entries(i)) {
      if (typeof w != "number")
        continue;
      const f = U(h);
      c[p][f] = w;
    }
  }
  return c;
}
function U(e) {
  return qe(new Uint8Array(e.split(",").map((t) => Number(t))), "hex");
}
function st(e) {
  return e * 1e6;
}
function Ke(e) {
  return e / 1e6;
}
function Ge(e) {
  if (e.length % 2 !== 0) throw new Error("Hex string must have an even length");
  const t = new Uint8Array(e.length / 2);
  for (let n = 0; n < e.length; n += 2)
    t[n / 2] = Number.parseInt(e.substring(n, n + 2), 16);
  return t;
}
function $e(e) {
  return e.startsWith("addr") || e.startsWith("stake");
}
function Ye(e) {
  return re(e) ? e.startsWith("e0") ? "stake_test" : "stake" : e.startsWith("00") ? "addr_test" : "addr";
}
function j(e) {
  if (!e)
    return;
  if ($e(e))
    return e;
  const t = Ye(e), n = Ge(e), s = q.toWords(n);
  return q.encode(t, s, 1e3);
}
function N() {
  return {
    isConnected: !1,
    isConnecting: !1,
    isConnectingTo: void 0,
    handler: void 0,
    balanceEncoded: void 0,
    balanceDecoded: void 0,
    balanceLovelace: void 0,
    balanceAda: void 0,
    changeAddressHex: void 0,
    changeAddressBech32: void 0,
    stakeAddressHex: void 0,
    stakeAddressBech32: void 0,
    networkId: void 0,
    supported: void 0,
    key: void 0,
    icon: void 0,
    website: void 0,
    displayName: void 0,
    supportsTxChaining: void 0,
    isUpdatingUtxos: !1,
    utxos: void 0
  };
}
const Je = $(
  (e, t, {
    config: n = F.config,
    lifecycle: s = new Y(),
    connect: r = ke,
    utxosUpdate: c = new He(),
    maxUtxosUpdateRetryCount: a = 8,
    utxosUpdateRetryInterval: i = 5e3
  } = {}) => {
    const p = async () => {
      var o;
      return ((o = c.runningUpdate) == null ? void 0 : o.promise) ?? t().utxos ?? [];
    }, h = new fe({
      setState: e,
      getState: t,
      newState: N,
      createConnection: async (o, l) => {
        const u = Be(
          await r(o),
          async () => {
            if (!await u.reenable())
              throw new J(
                `Could not reenable ${u.info.displayName} wallet after account change`
              );
            return T().catch(async (y) => {
              await h.handleUpdateError(y), await h.disconnect();
            }), u;
          },
          () => u.defaultApi.isEnabled()
        );
        if (l.signal.aborted)
          throw new ge();
        const x = async ({ expectChange: v = !1 } = {}) => {
          const y = t(), A = y.utxos ? [...y.utxos] : void 0;
          let k = 0, W = await u.getUtxos();
          for (; v && typeof A < "u" && k++ < a && pe(A, W); )
            await new Promise((H) => {
              setTimeout(async () => {
                W = await u.getUtxos(), H();
              }, i);
            });
          return W;
        }, C = ({ expectChange: v = !1 } = {}) => {
          const y = c.start({ lifecycle: s });
          x({ expectChange: v }).then((A) => {
            const k = A ?? [];
            !y.update.signal.aborted && !u.isDisconnected && e({ isUpdatingUtxos: !1, utxos: k }), y.resolve(k);
          }).catch((A) => {
            h.handleUpdateError(new he(O(A))).then(() => {
              !y.update.signal.aborted && !u.isDisconnected && e({ isUpdatingUtxos: !1, utxos: [] }), y.resolve([]);
            });
          });
        }, T = async () => {
          if (u.isDisconnected) {
            await m();
            return;
          }
          const v = await u.getBalance(), y = ie(v), A = Ve(y, "lovelace"), k = await u.getChangeAddressHex(), W = t(), H = v !== W.balanceEncoded, oe = k !== W.changeAddressHex, P = {
            isConnected: !0,
            isConnecting: !1,
            isConnectingTo: void 0,
            handler: u,
            balanceEncoded: v,
            balanceDecoded: y,
            balanceLovelace: A,
            balanceAda: Ke(A),
            networkId: await u.getNetworkId(),
            changeAddressHex: k,
            changeAddressBech32: await u.getChangeAddressBech32(),
            stakeAddressHex: await u.getStakeAddressHex(),
            stakeAddressBech32: await u.getStakeAddressBech32(),
            ...u.info
          };
          l.signal.aborted || (oe && w(P), H && (C({ expectChange: H }), P.isUpdatingUtxos = !0), u.isDisconnected || e(P));
        };
        return {
          updateState: T
        };
      },
      walletStorageKey: "connectedWallet",
      configStore: n,
      lifecycle: s
    }).on("beforeDisconnect", () => {
      var o;
      c.runningUpdate && (c.runningUpdate.signal.aborted = !0, c.runningUpdate.resolve([])), (o = t().handler) == null || o.disconnect();
    }).on("afterDisconnect", () => w(N())).on("afterConnect", ({ newState: o }) => w(o)), w = (o) => {
      n.enablePersistence && (o.key ? n.storage.set(E.connectedWallet, o.key) : n.storage.remove(E.connectedWallet), o.changeAddressHex ? n.storage.set(E.connectedChange, o.changeAddressHex) : n.storage.remove(E.connectedChange), o.stakeAddressHex ? n.storage.set(E.connectedStake, o.stakeAddressHex) : n.storage.remove(E.connectedStake));
    }, f = async (o, l) => (await h.disconnect(), await h.connect(o, { configOverrides: l })), b = async (o, { onSuccess: l, onError: u, ...x } = {}) => {
      f(o, x).then((C) => {
        l == null || l(C);
      }).catch((C) => {
        u == null || u(C);
      });
    }, m = () => h.disconnect(), _ = () => {
      h.init({ initialState: g });
    }, D = (o) => {
      let l, u, x;
      const C = typeof window < "u" && n.enablePersistence;
      if (typeof (o == null ? void 0 : o.tryToReconnectTo) == "string")
        l = o.tryToReconnectTo;
      else if (o != null && o.tryToReconnectTo) {
        l = o.tryToReconnectTo.wallet;
        let y = o.tryToReconnectTo.change;
        !y && C && (y = n.getPersistedValue(E.connectedChange)), Oe(y) && (u = y);
        let A = o.tryToReconnectTo.stake;
        !A && C && (A = n.getPersistedValue(E.connectedStake)), re(A) && (x = A);
      }
      !l && C && (l = n.getPersistedValue(E.connectedWallet)), l || (u = void 0, x = void 0);
      const T = j(u), v = j(x);
      e({
        isConnectingTo: l,
        isConnecting: !!l,
        changeAddressHex: u,
        stakeAddressHex: x,
        changeAddressBech32: T,
        stakeAddressBech32: v
      }), g.isConnectingTo = l, g.isConnecting = !!l, g.changeAddressHex = u, g.stakeAddressHex = x, g.changeAddressBech32 = T, g.stakeAddressBech32 = v;
    }, d = () => {
      h.cleanup();
    }, g = {
      ...N(),
      connect: b,
      connectAsync: f,
      disconnect: m,
      ensureUtxos: p,
      __init: _,
      __cleanup: d,
      __persist: D,
      __mngr: h
    };
    return g;
  }
);
async function Qe(e) {
  e.customWallets !== !1 && await Promise.all(
    be(L).map(async ([t, n]) => {
      var s;
      if (typeof e.customWallets == "object" && "blacklist" in e.customWallets && e.customWallets.blacklist.includes(t)) {
        e.debug && console.warn("[WELD] Initialization of", t, "canceled: Wallet is blacklisted");
        return;
      }
      if (typeof e.customWallets == "object" && "whitelist" in e.customWallets && !e.customWallets.whitelist.includes(t)) {
        e.debug && console.warn("[WELD] Initialization of", t, "canceled: Wallet is not whitelisted");
        return;
      }
      try {
        await ((s = n.initialize) == null ? void 0 : s.call(n)), e.debug && console.info("[WELD] Initialization of", t, "succeeded");
      } catch (r) {
        e.debug && console.warn(
          "[WELD] Initialization of",
          t,
          "custom wallet failed:",
          O(r)
        );
      }
    })
  );
}
function Xe() {
  let e, t, n;
  return {
    get config() {
      return e || (e = we()), e;
    },
    get wallet() {
      return t || (t = Je({ config: this.config })), t;
    },
    get extensions() {
      return n || (n = Te({ config: this.config })), n;
    },
    persist(s) {
      var r;
      this.config.persist(), this.wallet.persist({ tryToReconnectTo: (r = s == null ? void 0 : s.wallet) == null ? void 0 : r.tryToReconnectTo }), this.extensions.persist();
    },
    init({ persist: s = !0 } = {}) {
      Qe(this.config.getState()), typeof s == "object" ? this.persist(s) : s && this.persist(), this.config.init(), this.wallet.init(), this.extensions.init();
    },
    cleanup() {
      this.config.cleanup(), this.wallet.cleanup(), this.extensions.cleanup();
    }
  };
}
const F = Xe();
export {
  Oe as a,
  We as b,
  ke as c,
  Xe as d,
  Te as e,
  Je as f,
  Ue as g,
  te as h,
  re as i,
  ne as j,
  je as k,
  Pe as l,
  ie as m,
  ee as n,
  st as o,
  Ve as p,
  Ke as q,
  $e as r,
  j as s,
  F as w
};
